export default __webpack_public_path__ + "svg/Showrunnr_logomark_CMYK-83801866.svg";